import { PORTS } from "../config/modulePort";
import api from "./Api";

const PICKLIST_URL = process.env.REACT_APP_PICKLIST_URL || ""; // Default to an empty string or another default value

const picklistAPI = api(PICKLIST_URL);
// Define Address interface based on the expected structure of your Address object
interface Addresss {
  stakeholderId: number; // Assuming that stakeholderId exists on each Address object
  // Other fields of Address can be added here if needed
}

interface ApiResponse<T> {
  isSuccess: boolean;
  statusCode: number;
  message: string;
  result: T;
  timestamp: string;
}

interface StakeholderResponse {
  responseCode: number;
  id: number;
  message: string | null;
}

export interface Address {
  stakeholderId: number;
  addressTypeId: number;
  addressLine1: string;
  addressLine2: string;
  addressLine3: string;
  city: string;
  county: string;
  state: string;
  zipCode: string;
  country: string;
  phoneNumber: string;
  faxNumber: string;
  isPrimary: number;
  comments: string;
  createdBy: number;
}

export interface FetchZipCodeRequest {
  SearchString: string;
  pageNo: number;
  pageSize: number;
  sortColumn: string;
  sortOrder: string;
}

export interface StackHolderHeaderRequest {
  entityName: string;
  stakeholderTypeId: number;
  comments: string;
  createdBy: number;
  stakeholderId: number;
}
export interface StachHolderTypeRequest {
  groupName: string;
  triggerById: number;
}
interface GetStakeHolderHeaderResponse {
  isSuccess: boolean;
  statusCode: number;
  message: string;
  result: Stakeholder;
  timestamp: string;
}

interface Stakeholder {
  id: number;
  stakeholderid: number;
  tenantid: number;
  entityname: string;
  stakeholdertypeid: number;
  stakeholdertypedesc: string;
  comments: string;
  isactive: number;
  createdby: number;
  createdbyname: string;

  createddate: string;
  modifiedby: number;
  modifiedbyname: string;
  modifieddate: string;
}
export interface StackHolderHeaderResponse {
  result: number;
  isSuccess: boolean;
  message: string;
  statusCode: number;
}

export const fetchStakeholderList = async (params: any): Promise<any> => {
  try {
    const response = await picklistAPI.post("/api/stakeholder/search", params);
    const updatedResult = response.data?.result.map((user: any) => ({
      ...user,
      actions: { Edit: "Edit" },
    }));
    return updatedResult;
  } catch (error) {
    console.error("Error fetching the data:", error);
    throw new Error("Unable to fetch the data. Please try again later.");
  }
};

export const addStackeholderAddress = async (params: any): Promise<any> => {
  try {
    const response = await picklistAPI.post(
      "/api/stakeholder/address/add",
      params
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching the data:", error);
    throw new Error("Unable to add the data. Please try again later.");
  }
};

export const updateStackeholderAddress = async (params: any): Promise<any> => {
  try {
    const response = await picklistAPI.put(
      "/api/stakeholder/address/update",
      params
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching the data:", error);
    throw new Error("Unable to add the data. Please try again later.");
  }
};

export const searchZipCode = async (
  data: FetchZipCodeRequest
): Promise<ApiResponse<Address[]>> => {
  try {
    const response = await picklistAPI.post<ApiResponse<Address[]>>(
      "/api/address/searchzipcode",
      data
    );
    return response.data;
  } catch (error) {
    console.error("Error validating the zip code:", error);
    throw new Error("Unable to validate the zip code. Please try again later.");
  }
};
export const AddStackHolderHeader = async (
  formData: FormData
): Promise<ApiResponse<StakeholderResponse>> => {
  try {
    const response = await picklistAPI.post<ApiResponse<StakeholderResponse>>(
      "/api/stakeholder/headerinfo/add",
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(
      "Unable to add the stakeholder header. Please try again later."
    );
  }
};

export const UpdateStackHolderHeader = async (
  formData: FormData
): Promise<ApiResponse<StakeholderResponse>> => {
  try {
    const response = await picklistAPI.put<ApiResponse<StakeholderResponse>>(
      "/api/stakeholder/headerinfo/update",
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(
      "Unable to update the stakeholder header. Please try again later."
    );
  }
};

export const StachHolderTypes = async (
  data: StachHolderTypeRequest
): Promise<ApiResponse<Address[]>> => {
  try {
    const response = await picklistAPI.post<ApiResponse<Address[]>>(
      "/api/picklist/items/bygroupname",
      data
    );
    return response.data;
  } catch (error) {
    throw new Error("Unable to validate the zip code. Please try again later.");
  }
};
export const GetHeaderInfo = async (
  stakeholderid: number
): Promise<GetStakeHolderHeaderResponse | any> => {
  try {
    const response = await picklistAPI.get(
      `/api/stakeholder/headerinfo?stakeholderid=${stakeholderid}`
    );
    return response.data as GetStakeHolderHeaderResponse; // Type assertion
  } catch (error) {
    console.error("Error:", error);
    return undefined; // Returning undefined if there's an error
  }
};

export const GetAddressList = async (stakeholderid: number): Promise<any> => {
  try {
    const response = await picklistAPI.get(
      `/api/stakeholder/addresses?stakeholderid=${stakeholderid}`
    );

    const updatedResult = response.data?.result.map((address: any) => ({
      ...address,
      actions: { Edit: "Edit" }, // Adding Edit action inside each address entry
    }));

    return updatedResult;
  } catch (error) {
    console.error("Error fetching the address list:", error);
    throw new Error("Unable to fetch address data. Please try again later.");
  }
};

export const GetStakeholderContactInfo = async (
  contactID: any
): Promise<any> => {
  try {
    const response = await picklistAPI.get(
      `/api/stakeholder/contacts?stakeholderid=${contactID}`
    );
    const updatedResult = response.data?.result.map((user: any) => ({
      ...user,
      contactusernameEdit: user?.contactusername,
      contactusername: user?.contactusername?.split(" (U)")[0],
      actions: { Edit: "Edit" }, // Add the actions field to each user
    }));

    return updatedResult;
  } catch (error) {
    console.error("Error fetching team data:", error);
    throw new Error("Failed to fetch the team data. Please try again.");
  }
};

export const addStakeholderContact = async (
  contactData: any
): Promise<ApiResponse<any>> => {
  try {
    const response = await picklistAPI.post(
      "/api/stakeholder/contact/add",
      contactData
    );

    return response.data;
  } catch (error) {
    console.error("Error adding a new user:", error);
    throw new Error(
      "Failed to add the user. Please check the data and try again."
    );
  }
};

export const updateStakeholderContact = async (
  contactData: any
): Promise<ApiResponse<any>> => {
  try {
    const response = await picklistAPI.put(
      "/api/stakeholder/contact/update",
      contactData
    );

    return response.data;
  } catch (error) {
    console.error("Error adding a new user:", error);
    throw new Error(
      "Failed to add the user. Please check the data and try again."
    );
  }
};

export const getuserName = async (
  stakeholderId: any,
  webRoleId: any
): Promise<any> => {
  try {
    // Build the query string based on whether webRoleId is provided
    let url = `/api/stakeholder/contact/userlist?stakeholdertypeid=${stakeholderId}`;
    if (webRoleId !== null && webRoleId !== undefined) {
      url += `&webRoleId=${webRoleId}`;
    }

    const response = await picklistAPI.get(url);
    return response.data?.result;
  } catch (error) {
    console.error("Error fetching user data:", error);
    throw new Error("Failed to fetch the user data. Please try again.");
  }
};

export const searchHospitalClinic = async (search: any): Promise<any> => {
  try {
    const response = await picklistAPI.get(
      `/api/stakeholder/contact/medicare/search?searchString=${search}`
    );
    return response.data;
  } catch (error) {
    console.error("Error validating the clinic code:", error);
    throw new Error(
      "Unable to validate the clinic code. Please try again later."
    );
  }
};

export const GetStakeholderContactClinicInfo = async (
  contactID: any
): Promise<any> => {
  try {
    const response = await picklistAPI.get(
      `/api/stakeholder/contact/medicarelist?stakeholderContactId=${contactID}`
    );

    const updatedResult = response.data?.result
      ?.filter((user: any) => user?.providerName)
      .map((user: any) => ({
        ...user,
        contactusernameEdit: user?.contactusername,
        contactusername: user?.contactusername?.split(" (U)")[0],
        actions: { Edit: "Edit" }, 
      }));

    return updatedResult;
  } catch (error) {
    console.error("Error fetching team data:", error);
    throw new Error("Failed to fetch the team data. Please try again.");
  }
};

export const addStakeholderContactClinic = async (
  clinicData: any
): Promise<ApiResponse<any>> => {
  try {
    const response = await picklistAPI.post(
      "/api/stakeholder/contact/medicare/add",
      clinicData
    );

    return response.data;
  } catch (error) {
    console.error("Error adding a new user:", error);
    throw new Error(
      "Failed to add the user. Please check the data and try again."
    );
  }
};

export const updateStakeholderContactClinic = async (
  clinicData: any
): Promise<ApiResponse<any>> => {
  try {
    const response = await picklistAPI.post(
      "/api/stakeholder/contact/medicare/update",
      clinicData
    );

    return response.data;
  } catch (error) {
    console.error("Error adding a new user:", error);
    throw new Error(
      "Failed to add the user. Please check the data and try again."
    );
  }
};

export const GetDoctorDetails = async (contactID: number): Promise<any> => {
  try {
    const response = await picklistAPI.get(
      `/api/stakeholder/doctor/details?stakeholderContactId=${contactID}`
    );

    const result = response.data?.result;
    // Parse the JSON string safely
    const associatedLocations = result?.associatedLocationJson
      ? JSON.parse(result.associatedLocationJson)
      : [];

    // Transform into properly typed location objects
    const locationList: Location[] = associatedLocations.map((loc: any) => ({
      locationname: loc.locationname || "",
      locationaddress: loc.locationaddress || "",
      emailaddress: loc.emailaddress || "",
      phonenumber: loc.phonenumber || "",
      faxnumber: loc.faxnumber || "",
      latitude: loc?.latitude || null,
      longitude: loc?.longitude || null,
      count: loc?.TotalAppointmentsCount || 0,
    }));
    return {
      doctorName: result?.doctorName?.trim(),
      specialization: result?.specialization,
      experienceInYears: result?.experienceInYears,
      emailAddress: result?.emailAddress,
      phoneNumber: result?.phoneNumber,
      faxNumber: result?.faxNumber,
      associatedLocations: locationList,
    };
  } catch (error) {
    console.error("Error fetching doctor details:", error);
    throw new Error("Failed to fetch doctor details. Please try again.");
  }
};

export const searchManualZipCode = async (
  data: FetchZipCodeRequest
): Promise<any> => {
  try {
    const response = await picklistAPI.post("/api/address/searchzipcode", data);
    return response.data;
  } catch (error) {
    console.error("Error validating the zip code:", error);
    throw new Error("Unable to validate the zip code. Please try again later.");
  }
};

export const getUserRoleForPMC = async (): Promise<any> => {
  try {
    const response = await picklistAPI.get(`/api/common/application/roles`);
    return response.data?.result;
  } catch (error) {
    console.error("Error fetching user data:", error);
    throw new Error("Failed to fetch the user data. Please try again.");
  }
};

export const GetMedicalAssistant = async (
  caseInfoId: number
): Promise<any | any> => {
  try {
    const response = await picklistAPI.get(
      `/api/stakeholder/contact/medical-assistant-contacts?caseInfoId=${caseInfoId}`
    );
    return response.data as any; 
  } catch (error) {
    console.error("Error:", error);
    return undefined; 
  }
};

export const GetStakeholderLocationsList = async (
  stakeholderid: number
): Promise<any | any> => {
  try {
    const response = await picklistAPI.get(
      `/api/stakeholder/locations?stakeholderid=${stakeholderid}`
    );
    return response.data; 
  } catch (error) {
    console.error("Error getting GetStakeHolderLocations :", error);
    throw new Error(
      "Failed getting GetStakeHolderLocations. Please check the data and try again."
    );
  }
};
